import React from 'react'
import { useTracking } from 'react-tracking'

import Page from './PageBackground'

const TrackedPage = props => {
  useTracking(props.trackingData, {
    dispatchOnMount: () => ({ category: 'pageview', event: 'pageview' }),
  })

  return <Page {...props} />
}

export default TrackedPage
